<template>
<w-panel>
  <el-table-wrapper ref="targetTestDeviceList" slot="body" :show-custom-header="false"  @selection-change="targetChangeSelection" :data="dataList" :columns="deviceColumns" :column-default="columnDefault" style="width:100%;">
  </el-table-wrapper>
</w-panel>
</template>

<script>
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';

export default {
  name: 'WTargetTestDeviceList',
  components: {
  },
  props: {
    activeCompanyId: Number,
  },
  data() {
    return {
      dataList: null,
      changeDeviceList: [],
      columnDefault,
      deviceColumns: [
        {
          align: 'center',
          width: 50,
          type: 'selection',
        },
        {
          prop: 'objName',
          label: '장비명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  methods: {
    initTargetInfo() {
      NetdeviceSettingAPI.getNmsObjList({ objCompanyId: this.activeCompanyId }).then((response) => {
        if (response.data.success) {
          this.dataList = response.data.data;
        }
      });
    },
    targetChangeSelection(selectVal) {
      this.changeDeviceList = selectVal;
      this.$emit('changeSize', this.changeDeviceList.length);
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/ScriptSettings/component/TargetTestDeviceList.vue